export default "__VITE_ASSET__b6b0d97c__"